"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var common_1 = __importDefault(require("../common"));

var Facebook = function Facebook(_a) {
  var rest = __rest(_a, []);

  return react_1["default"].createElement(common_1["default"], Object.assign({
    "data-icon": "facebook",
    viewBox: "0 0 32 32"
  }, rest), react_1["default"].createElement("g", {
    id: "Pages",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, react_1["default"].createElement("g", {
    id: "Mobile---Menu",
    transform: "translate(-60.000000, -518.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, react_1["default"].createElement("g", {
    id: "Group-11",
    transform: "translate(60.000000, 518.000000)"
  }, react_1["default"].createElement("g", {
    id: "Social_icons_black"
  }, react_1["default"].createElement("g", {
    id: "Facebook"
  }, react_1["default"].createElement("path", {
    d: "M0,16 C0,7.16344357 7.16344357,0 16,0 C24.8365564,0 32,7.16344357 32,16 C32,24.8365564 24.8365564,32 16,32 C7.16344357,32 0,24.8365564 0,16 Z M17.6677034,25.4076511 L17.6677034,16.7028064 L20.0706212,16.7028064 L20.3890597,13.7030687 L17.6677034,13.7030687 L17.6717859,12.2016711 C17.6717859,11.4192933 17.7461223,11.0000774 18.8698427,11.0000774 L20.3720491,11.0000774 L20.3720491,8 L17.9687911,8 C15.0820917,8 14.0660483,9.45519552 14.0660483,11.9023768 L14.0660483,13.7034084 L12.2666667,13.7034084 L12.2666667,16.7031461 L14.0660483,16.7031461 L14.0660483,25.4076511 L17.6677034,25.4076511 Z",
    id: "Combined-Shape"
  })))))));
};

exports["default"] = Facebook;